import { computed, useStore } from '@nuxtjs/composition-api'
import { checkAxiosData } from 'fe-common'
import { concatMap, from, filter, tap, catchError, empty } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'
import useErrorHandler from './useErrorHandler'
import useVeeValidate from './useVeeValidate'

export default function useForgotPassword(context) {
  const store = useStore()

  const imageSrc = computed({
    get() {
      return store.state.authModule.imageSrc
    },
    set(value) {
      store.commit('authModule/IMAGE_SRC', value)
    }
  })
  const imageCode = computed({
    get() {
      return store.state.authModule.imageCode
    },
    set(value) {
      store.commit('authModule/IMAGE_CODE', value)
    }
  })
  const imageToken = computed({
    get() {
      return store.state.authModule.imageToken
    },
    set(value) {
      store.commit('authModule/IMAGE_TOKEN', value)
    }
  })
  const fpUsername = computed({
    get() {
      return store.state.authModule.fpUsername
    },
    set(value) {
      store.commit('authModule/FP_USERNAME', value)
    }
  })
  const fpTel = computed({
    get() {
      return store.state.authModule.fpTel
    },
    set(value) {
      store.commit('authModule/FP_TEL', value)
    }
  })
  const fpEmail = computed({
    get() {
      return store.state.authModule.fpEmail
    },
    set(value) {
      store.commit('authModule/FP_EMAIL', value)
    }
  })
  const fpCountryCode = computed({
    get() {
      return store.state.authModule.fpCountryCode
    },
    set(value) {
      store.commit('authModule/FP_COUNTRY_CODE', value)
    }
  })

  const { errorHandler, responseCodeToMessage } = useErrorHandler(context)
  const { reset } = useVeeValidate(context)

  function refreshData() {
    fpUsername.value = null
    fpTel.value = null
    fpCountryCode.value = null
    fpEmail.value = null
    refreshImageSrc()
    reset()
  }
  function refreshImageSrc() {
    imageSrc.value = null
    imageCode.value = null
    imageToken.value = null
    store.dispatch('authModule/getImageSrc').catch(err => {
      errorHandler(err)
    })
    reset('imageCode')
  }
  function forgotPassword(successCallback) {
    from(store.dispatch('startLoading'))
      .pipe(
        concatMap(() => from(store.dispatch('authModule/forgotPassword'))),
        filter(data =>
          checkAxiosData(data, {
            handleMessages: handleMessages({
              store
            })
          })
        ),
        tap(({ code }) => {
          context.root.$swal({
            type: 'success',
            title: context.root.$t('common.successOperation'),
            html: responseCodeToMessage(code)
          })
        }),
        tap(() => successCallback()),
        catchError(err => {
          errorHandler(err)
          refreshImageSrc()
          reset()
          return empty()
        })
      )
      .subscribe({
        complete: () => store.dispatch('completeLoading')
      })
  }

  return {
    imageSrc,
    imageCode,
    imageToken,
    fpUsername,
    fpTel,
    fpEmail,
    fpCountryCode,

    refreshData,
    refreshImageSrc,
    forgotPassword
  }
}
